export default {
  getOrders: state => {
    return state.orders;
  },
  GET_ORDER_USER: state => state.orderCurrentUser,
  GET_INVALID_ORDER: state => state.invalidOrder
};
